import { useQuery } from '@apollo/client';

import GET_DOWNLOADABLE_RESOURCE_DETAIL from '../graphql/GetDownloadableResourceDetail.graphql';
// biome-ignore lint/style/useImportType: legacy import, will be migrated
import {
  GetDownloadableResourceDetail,
  GetDownloadableResourceDetailVariables,
} from '../graphql/types/GetDownloadableResourceDetail';

const useGetResource = (slug: string) => {
  const response = useQuery<
    GetDownloadableResourceDetail,
    GetDownloadableResourceDetailVariables
  >(GET_DOWNLOADABLE_RESOURCE_DETAIL, {
    variables: {
      slug,
    },
  });

  return response?.data?.resource;
};

export default useGetResource;
